/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import { actions as systemModalActions, OverlayBlur } from '../redux/ducks/systemModal';

import DatePicker from './DatePicker';
import DateUtil from '../../utilities/DateUtil';
import { Inputs } from '../../bphComponents/bundle';

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    dismissModal: () => {
      dispatch(systemModalActions.dismiss());
    },
    showModal: (content) => {
      dispatch(systemModalActions.show(content, { blurSize: OverlayBlur.lightSmallBlur }));
    },
  };
}

class DatePickerToggle extends React.Component {

  constructor(props) {
    super(props);

    this.toggleToDatePicker = this.toggleToDatePicker.bind(this);
    this.finishedDatePicking = this.finishedDatePicking.bind(this);
    this.closeDatePicker = this.closeDatePicker.bind(this);

    this.elRef = React.createRef();

    this.state = {
      isResting: !this.props.initialFocus,
    };
  }

  componentDidMount() {
    if (this.props.initialFocus) {
      this.showPicker();
    }
  }

  showPicker = () => {
    const { left, width, top } = this.elRef.current.getBoundingClientRect();

    this.props.showModal(
      <div style={{ position: 'fixed', top, width, left }}>
        <DatePicker
          label={this.props.label}
          date={this.props.date}
          precision={this.props.precision}
          onDateSubmit={this.finishedDatePicking}
          defaultDate={this.props.defaultDate}
          defaultPrecision={this.props.defaultPrecision}
          isFuzzy={this.props.isFuzzy}
          hasToday={this.props.hasToday}
          earliestDateLimit={this.props.earliestDateLimit}
          latestDateLimit={this.props.latestDateLimit}
          allowNull={this.props.allowNull}
        />
      </div>
    );
  }

  toggleToDatePicker() {
    this.setState({
      isResting: false,
    });

    this.showPicker();

    if (this.props.onFocus) {
      this.props.onFocus();
    }
  }

  finishedDatePicking(dateData) {
    if (dateData) {
      this.props.onChange(dateData);
    } else if (this.props.onCancel) {
      this.props.onCancel();
    }

    this.setState({
      isResting: true,
    });
    this.props.dismissModal();
  }

  closeDatePicker() {
    this.setState({
      isResting: true,
    });
    this.props.dismissModal();
  }

  render() {
    const precision = this.props.isFuzzy ? this.props.precision : 'P1D';
    const regularHint = this.props.warningHint && this.props.date && DateUtil.isBefore(this.props.date, this.props.earliestDateWarningLimit) ? (
      <>
        {this.props.regularHint}
        <span style={{ marginLeft: '5px' }} className="font-color-warning">
          <FormattedMessage id={this.props.warningHint} />
        </span>
      </>
     ) : this.props.regularHint;

    return (
      <div style={{ width: '100%' }} ref={this.elRef}>
        <Inputs.TextInput
          value={DateUtil.formattedMediumDate(this.props.date, precision)}
          label={this.props.label ? this.props.intl.formatMessage({ id: this.props.label }) : ''}
          onFocus={this.toggleToDatePicker}
          onChange={() => {}}
          isInvalid={!!this.props.invalidHint}
          invalidHint={this.props.invalidHint}
          onClear={() => { this.props.onChange({ date: '', precision: '' }); }}
          regularHint={regularHint}
          noForcedHeight={true}
          preventFloating={true}
          color={this.props.color}
          readOnly={true}
        >
          {this.props.children}
        </Inputs.TextInput>
      </div>
    );
  }
}
DatePickerToggle.propTypes = {
  intl: PropTypes.object,
  children: PropTypes.any,
  invalidHint: PropTypes.any,
  warningHint: PropTypes.any,
  earliestDateWarningLimit: PropTypes.string,
  label: PropTypes.any.isRequired,
  date: PropTypes.string.isRequired,
  precision: PropTypes.string,
  defaultDate: PropTypes.string,
  defaultPrecision: PropTypes.string,
  isFuzzy: PropTypes.bool,
  hasToday: PropTypes.bool,
  allowNull: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  initialFocus: PropTypes.bool,
  onFocus: PropTypes.func,
  onCancel: PropTypes.func,
  earliestDateLimit: PropTypes.string,
  latestDateLimit: PropTypes.string,
  displayFormat: PropTypes.oneOf(['medium', 'long']),
  hideLabel: PropTypes.bool,
  color: PropTypes.string,
  regularHint: PropTypes.any,
  showModal: PropTypes.func,
  dismissModal: PropTypes.func,
};
DatePickerToggle.defaultProps = {
  displayFormat: 'medium',
};
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(DatePickerToggle));
